import { Box, Grid, Skeleton } from "@mui/material";
import { type FunctionComponent } from "react";

export const WPArticleGridSkeleton: FunctionComponent = ({ ...restProps }) => {
    return (
        <Box {...restProps} mb={5}>
            <Grid
                container
                columns={{
                    lg: 12,
                    md: 12,
                    sm: 8,
                    xl: 12,
                    xs: 4,
                }}
                spacing={4}
            >
                {[...Array(8)].map((_, index) => (
                    <Grid item xs={2} sm={2} md={4} lg={3} xl={3} key={`skeleton_${index}`}>
                        <Skeleton height={185} />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};
